import styled from 'styled-components';

export const Content = styled.div`
  padding: 8px;
  min-height: 50px;
  box-sizing: border-box;
  flex-grow: 0;

  /* width: 247px; */
  font-size: 14px;
  white-space: nowrap;
  line-height: 1;
  background-color: #1a1a1a; //#5d6871;
  border: 1px solid #646468;
  border-radius: 10px;
  color: #ddd;
  cursor: grab;
  &.common {
    /* background-color:#2d3841; */
  }
`;

export const Name = styled.div`
  margin: 0 0 5px;
  color: #ddd;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Zones = styled.div`
`;
